///Gross
export default function GridPlotGridLabels(
   userTheme,
   plotData,
   plotConfigs,
   sizer,
   plotOffset,
) {
   //Read plot labels from plotData
   let xLabels = [];
   let yLabels = [];
   plotData.forEach((p) => {
      if (!xLabels.includes(p[4])) {
         xLabels.push(p[4]);
      }
      if (!yLabels.includes(p[5])) {
         yLabels.push(p[5]);
      }
   });

   //The common text graphic config
   const ECLGraphicConfig = {
      type: "text",
      cursor: "normal",
      style: {
         font: 'bolder 18px "Noto Sans", sans-serif',
         overflow: "truncate",
         ellipsis: "...",
         fill: userTheme === "Dark" ? "white" : "black",
         textAlign: "center",
         backgroundColor: userTheme === "Dark" ? "#222222" : "#EFEFEE",
      },
   };

   let graphicsConfig = [];

   xLabels.forEach((x, i) => {
      const xLabelConfig = {
         ...ECLGraphicConfig,
         left: sizer.leftOffset + i * sizer.gridWidth * plotOffset,
         style: {
            ...ECLGraphicConfig.style,
            text: x,
            width: sizer.gridWidth - 20,
            textAlign: "left",
         },
      };

      if (plotConfigs.some((p) => p.topAxis)) {
         graphicsConfig.push({
            ...xLabelConfig,
            top: 45,
         });
      }
      if (
         plotConfigs.some((p) => p.bottomAxis) ||
         plotConfigs.some((p) =>
            p.series.some((s) => s.type === "pie" || s.type === "measure"),
         )
      ) {
         graphicsConfig.push({
            ...xLabelConfig,
            bottom: 0,
         });
      }
   });

   yLabels.forEach((y, i) => {
      const yLabelConfig = {
         ...ECLGraphicConfig,
         top: sizer.topOffset + i * sizer.gridHeight,
         rotation: 1.57, // radians
         style: {
            ...ECLGraphicConfig.style,
            text: y,
            width: sizer.gridHeight - 20, // -20 to fit grid padding
            textAlign: "center",
            backgroundColor: userTheme === "Dark" ? "#222222" : "#EFEFEE",
         },
      };

      if (
         plotConfigs.some((p) => p.leftAxis) ||
         plotConfigs.some((p) =>
            p.series.some((s) => s.type === "pie" || s.type === "measure"),
         )
      ) {
         graphicsConfig.push({
            ...yLabelConfig,
            left: 15,
         });
      }

      if (plotConfigs.some((p) => p.rightAxis)) {
         graphicsConfig.push({
            ...yLabelConfig,
            right: 15,
         });
      }
   });

   return graphicsConfig;
}
